import {
  ClockCircleOutlined,
  CloseOutlined,
  EditOutlined
} from "@ant-design/icons";
import { Button, Input, Modal } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { AnnuleerButton } from "~/components/buttons/AnnuleerButton.jsx";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { $t } from "~/i18n.js";
import { OGNtimeIcon, OGNwarningText } from "./Ogn.jsx";

export const TijdKnopAndEdit = ({
  buttonAction,
  fieldName,
  buttonIcon,
  readOnly,
  currentTime,
  notActive,
  width,
  ogn_indicator,
  saveTime,
  size = "medium",
  vluchtduur,
  minTime = null,
  maxTime = null,
  type = "default",
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loadingAction, setLoadingAction] = useState("");

  const [newTime, setNewTime] = useState(currentTime);
  useEffect(() => setNewTime(currentTime), [currentTime, showModal]);

  const timeError =
    newTime && minTime && newTime < minTime
      ? $t("Kan niet eerder zijn dan ${minTime}", { minTime })
      : newTime && maxTime && newTime > maxTime
      ? $t("Kan niet later zijn dan ${maxTime}", { maxTime })
      : null;

  const now = dayjs().format("HH:mm");

  const triggerSaveTime = async (action, newTime) => {
    setLoadingAction(action);
    if (newTime !== currentTime)
      await saveTime(newTime === "" ? null : newTime);
    resetAndClose();
  };

  const resetAndClose = () => {
    setLoadingAction("");
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <Modal
          width={340}
          title={$t("Wijzig ${fieldName}", { fieldName })}
          open={showModal}
          onCancel={resetAndClose}
          footer={[
            <SaveButton
              loading={loadingAction === "opslaan"}
              style={{ width: 120 }}
              key="slaan"
              disabled={!!timeError}
              onClick={() => triggerSaveTime("opslaan", newTime)}
            />,
            <AnnuleerButton key="annuleren" onClick={resetAndClose} />,
          ]}
        >
          <div style={{ padding: 12 }}>
            <div style={{ marginBottom: 24 }}>
              <OGNwarningText ogn_indicator={ogn_indicator} />

              <p>
                <span className="bold label">{$t("Huidige waarde")}</span>{" "}
                {currentTime}
              </p>
              {vluchtduur > 0 && (
                <p>
                  <span className="bold label">{$t("Huidige vluchtduur")}</span>{" "}
                  {vluchtduur} {$t("minuten")}
                </p>
              )}

              {minTime && (
                <p>
                  <span className="bold label">{$t("Minimale tijd")}</span>
                  {minTime}
                </p>
              )}
              {maxTime && (
                <p>
                  <span className="bold label">{$t("Maximale tijd")}</span>
                  {maxTime}
                </p>
              )}
            </div>

            <div className="row">
              <Button
                loading={loadingAction === "wis"}
                style={{ width: 120 }}
                onClick={() => setNewTime(null)}
                icon={<CloseOutlined />}
              >
                {$t("Wis tijd")}
              </Button>

              <Button
                loading={loadingAction === "nu"}
                style={{ width: 120, marginLeft: 6 }}
                onClick={() => setNewTime(now)}
                icon={<ClockCircleOutlined />}
              >
                {$t("Nu")} ({now})
              </Button>
            </div>

            <p style={{ marginTop: 12 }}>{$t("Wijzig tijd naar")}: </p>

            <div className="row">
              <Input
                size="large"
                type="time"
                allowClear={false}
                style={{
                  width: 120,
                  marginTop: 12,
                  marginRight: 6,
                  display: "flex",
                }}
                placeholder="hh:mm"
                value={newTime}
                onChange={(element) => setNewTime(element.target.value)}
                onPressEnter={() => !timeError && triggerSaveTime("opslaan", newTime)}
              />
            </div>
            {timeError && (
              <p style={{ color: "var(--errorColor, #ff4d4f)", marginTop: 8, fontSize: 12 }}>
                {timeError}
              </p>
            )}
          </div>
        </Modal>
      )}

      <div className="row" style={width && { width }}>
        {!currentTime ? (
          <>
            <Button
              size={size}
              disabled={readOnly || notActive}
              style={width && { width }}
              loading={loadingAction === "quickpress"}
              onClick={() =>
                triggerSaveTime("quickpress", dayjs().format("HH:mm"))
              }
              icon={buttonIcon}
              type={type}
            >
              {buttonAction}
            </Button>
          </>
        ) : (
          <>
            <Button
              size={size}
              type="default"
              disabled={readOnly}
              style={width && { width }}
              onClick={() => setShowModal(true)}
              icon={
                <OGNtimeIcon
                  ogn_indicator={ogn_indicator}
                  defaultIcon={buttonIcon}
                />
              }
            >
              {currentTime} <EditOutlined />
            </Button>
          </>
        )}
      </div>
    </>
  );
};
